
<!--
  Footer Image 
-->

<template lang="html">
    <div id="gallery-container">
      <lazy-component>
        <div class="container" id="gallery">
          <div class="row" id="gallery-mobile">
            <div class="col-md-offset-2 col-sm-offset-1 col-sm-10 col-md-8">
              <image-loader 
                class="image-loader-container"
                v-for="(item, index) in footer.array"
                :imgSrc="path+item.img"
                >
              </image-loader>
            </div>
          </div>
        </div>
      </lazy-component>
    </div>
</template>
<style type="text/css">

#gallery-container {
  background-color: #d1a699;
}
#gallery {
  min-height: 1000px;
}

@media (min-width: 576px) {

}
@media (min-width: 768px) {
  
}
@media (min-width: 992px) {
  
}

</style>

<script>
import { footer } from '../../content.json'
// import Intersect from 'vue-intersect'
import ImageLoader from '../components/ImageLoader'
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  observer: true,
  throttleWait: 3000,
  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  },
  lazyComponent: true
})

export default {
  name: 'footerimage',
  data () {
    return {
      footer,
      path: null
    }
  },
  methods: {
  },
  mounted: function () {
    this.path = (window.innerWidth < 576) ? 'footer/mobile/' : 'footer/'

  },
  components: {
    ImageLoader
  }
}

</script>



// WEBPACK FOOTER //
// FooterImage.vue?1109ddc2